export default __webpack_public_path__ + "static/refunds-8f844e23eef8e275348a14b5d5418faa.png";